import React, { useEffect } from 'react';
import { X } from 'lucide-react';
interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
  maxWidth?: 'sm' | 'md' | 'lg' | 'xl' | '2xl';
}
export function Modal({
  isOpen,
  onClose,
  title,
  children,
  maxWidth = '2xl'
}: ModalProps) {
  useEffect(() => {
    const handleEscape = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    if (isOpen) {
      document.addEventListener('keydown', handleEscape);
      document.body.style.overflow = 'hidden';
    }
    return () => {
      document.removeEventListener('keydown', handleEscape);
      document.body.style.overflow = 'unset';
    };
  }, [isOpen, onClose]);
  if (!isOpen) return null;
  const maxWidthClasses = {
    sm: 'max-w-sm',
    md: 'max-w-md',
    lg: 'max-w-lg',
    xl: 'max-w-xl',
    '2xl': 'max-w-2xl'
  };
  return <div className="fixed inset-0 z-50 flex items-center justify-center p-4" data-id="element-228">
      {/* Backdrop */}
      <div className="absolute inset-0 bg-slate-900/50 backdrop-blur-sm transition-opacity duration-200" onClick={onClose} aria-hidden="true" data-id="element-229" />

      {/* Modal */}
      <div className={`relative bg-white rounded-xl shadow-2xl w-full ${maxWidthClasses[maxWidth]} max-h-[90vh] overflow-hidden flex flex-col animate-in fade-in zoom-in-95 duration-200`} role="dialog" aria-modal="true" aria-labelledby="modal-title" data-id="element-230">
        {/* Header */}
        <div className="flex items-center justify-between p-6 border-b border-slate-200" data-id="element-231">
          <h2 id="modal-title" className="text-xl font-bold text-slate-900" data-id="element-232">
            {title}
          </h2>
          <button onClick={onClose} className="p-2 text-slate-400 hover:text-slate-600 hover:bg-slate-100 rounded-lg transition-colors" aria-label="Schließen" data-id="element-233">
            <X className="h-5 w-5" data-id="element-234" />
          </button>
        </div>

        {/* Content */}
        <div className="flex-1 overflow-y-auto p-6" data-id="element-235">{children}</div>
      </div>
    </div>;
}